var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "m-5 md:m-15 2xl:m-20",
    on: {
      "keydown": function ($event) {
        return _vm.progressbar.userKeyDown();
      },
      "keyup": function ($event) {
        return _vm.progressbar.userKeyUp();
      },
      "click": _vm.calculate_progress
    }
  }, [_c('h3', {
    staticClass: "mb-5 md:mb-15 2xl:mb-20"
  }, [_vm._v("Poste de travail")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-10"
  }, [_c('div', {
    staticClass: "col-span-full text-base text-indigo-600"
  }, [_vm._v("POSTURES PENIBLES")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-6",
    attrs: {
      "name": "type_posture",
      "libelle": "Type de posture",
      "necessary": true,
      "value": _vm.form.type_posture,
      "datas": [{
        value: 'Assis seulement'
      }, {
        value: 'Debout seulement'
      }, {
        value: 'Alternance assis-debout'
      }, {
        value: 'Accroupis'
      }, {
        value: 'A genoux'
      }, {
        value: 'Penché'
      }, {
        value: 'Rotations'
      }, {
        value: 'Bras tendus'
      }, {
        value: 'Bras levés'
      }, {
        value: 'Flexion/Extension du poignet'
      }, {
        value: 'Autres'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.type_posture = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-in duration-300",
      "enter-class": "opacity-0",
      "leave-active-class": "ease-out duration-300",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.form.type_posture === 'Autres' ? _c('input-text', {
    staticClass: "md:col-span-6",
    attrs: {
      "name": "type_posture_precis",
      "libelle": "Précisez (si autres)",
      "necessary": true,
      "value": _vm.form.type_posture_precis
    },
    on: {
      "input": function (newValue) {
        _vm.form.type_posture_precis = newValue;
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('input-text-area', {
    staticClass: "md:col-span-full",
    attrs: {
      "name": "type_posture_comment",
      "libelle": "Commentaires",
      "necessary": false,
      "value": _vm.form.type_posture_comment,
      "size": "3"
    },
    on: {
      "input": function (newValue) {
        _vm.form.type_posture_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full text-base text-indigo-600 mt-10"
  }, [_vm._v("MANIPULATIONS")]), _vm._v(" "), _c('multiple-select', {
    staticClass: "md:col-span-6",
    attrs: {
      "name": "type_manipulations",
      "libelle": "Type de manipulations",
      "necessary": true,
      "value": _vm.form.type_manipulations,
      "datas": [{
        value: 'Mono-manuelle'
      }, {
        value: 'Bi-manuelle'
      }, {
        value: 'Motricité fine'
      }, {
        value: 'Maintien de la main en position de supînation (rotation des paumes vers le haut)'
      }, {
        value: 'Maintien de la main en posture de pronation (rotation des paumes vers le bas)'
      }, {
        value: 'Autres'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.type_manipulations = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-in duration-300",
      "enter-class": "opacity-0",
      "leave-active-class": "ease-out duration-300",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.form.type_manipulations.includes('Autres') ? _c('input-text', {
    staticClass: "md:col-span-6",
    attrs: {
      "name": "type_manipulations_precis",
      "libelle": "Précisez (si autres)",
      "necessary": true,
      "value": _vm.form.type_manipulations_precis
    },
    on: {
      "input": function (newValue) {
        _vm.form.type_manipulations_precis = newValue;
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('input-text-area', {
    staticClass: "md:col-span-full",
    attrs: {
      "name": "type_manipulations_comment",
      "libelle": "Commentaires",
      "necessary": false,
      "value": _vm.form.type_manipulations_comment,
      "size": "3"
    },
    on: {
      "input": function (newValue) {
        _vm.form.type_manipulations_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full text-base text-indigo-600 mt-10"
  }, [_vm._v("CONTRAINTES D'EXPOSITION")]), _vm._v(" "), _c('multiple-select', {
    staticClass: "md:col-span-6",
    attrs: {
      "name": "type_contraintes",
      "libelle": "Type de contraintes",
      "necessary": true,
      "value": _vm.form.type_contraintes,
      "datas": [{
        value: 'Absences de contraintes d\'exposition'
      }, {
        value: 'Contraintes alimentaires'
      }, {
        value: 'Contraintes liées à l\'exposition au froid'
      }, {
        value: 'Contraintes liées à l\'exposition à la chaleur'
      }, {
        value: 'Contraintes liées à l\'exposition aux intempéries'
      }, {
        value: 'Contraintes liées à l\'exposition à l\'humidité'
      }, {
        value: 'Contraintes liées à l\'exposition aux poussières'
      }, {
        value: 'Contraintes liées à l\'exposition aux agents chimiques'
      }, {
        value: 'Contraintes liées à l\'exposition aux agents infectieux'
      }, {
        value: 'Contraintes liées à l\'exposition au stress'
      }, {
        value: 'Contraintes liées à l\'exposition au bruit'
      }, {
        value: 'Contraintes liées à l\'exposition à la luminosité'
      }, {
        value: 'Contraintes liées à l\'exposition à la foule'
      }, {
        value: 'Autres contraintes'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.type_contraintes = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-in duration-300",
      "enter-class": "opacity-0",
      "leave-active-class": "ease-out duration-300",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.form.type_contraintes.includes('Autres contraintes') ? _c('input-text', {
    staticClass: "md:col-span-6",
    attrs: {
      "name": "type_contraintes_precis",
      "libelle": "Précisez (si autres)",
      "necessary": true,
      "value": _vm.form.type_contraintes_precis
    },
    on: {
      "input": function (newValue) {
        _vm.form.type_contraintes_precis = newValue;
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('input-text-area', {
    staticClass: "md:col-span-full",
    attrs: {
      "name": "type_contraintes_comment",
      "libelle": "Commentaires",
      "necessary": false,
      "value": _vm.form.type_contraintes_comment,
      "size": "3"
    },
    on: {
      "input": function (newValue) {
        _vm.form.type_contraintes_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full text-base text-indigo-600 mt-10"
  }, [_vm._v("DEPLACEMENT DANS L'ENVIRONNEMENT DE TRAVAIL")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "deplacement_sans_port_charges",
      "libelle": "Déplacement sans port de charges",
      "necessary": true,
      "value": _vm.form.deplacement_sans_port_charges,
      "datas": [{
        value: 'Oui'
      }, {
        value: 'Non'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.deplacement_sans_port_charges = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "deplacement_sans_port_charges_duree",
      "libelle": "Durée",
      "necessary": true,
      "value": _vm.form.deplacement_sans_port_charges_duree
    },
    on: {
      "input": function (newValue) {
        _vm.form.deplacement_sans_port_charges_duree = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "deplacement_sans_port_charges_frequence",
      "libelle": "Fréquence",
      "necessary": true,
      "value": _vm.form.deplacement_sans_port_charges_frequence
    },
    on: {
      "input": function (newValue) {
        _vm.form.deplacement_sans_port_charges_frequence = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "lg:col-start-1 md:col-span-3",
    attrs: {
      "name": "deplacement_avec_port_charges",
      "libelle": "Déplacement avec port de charges",
      "necessary": true,
      "value": _vm.form.deplacement_avec_port_charges,
      "datas": [{
        value: 'Oui'
      }, {
        value: 'Non'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.deplacement_avec_port_charges = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "deplacement_avec_port_charges_duree",
      "libelle": "Durée",
      "necessary": true,
      "value": _vm.form.deplacement_avec_port_charges_duree
    },
    on: {
      "input": function (newValue) {
        _vm.form.deplacement_avec_port_charges_duree = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "deplacement_avec_port_charges_frequence",
      "libelle": "Fréquence",
      "necessary": true,
      "value": _vm.form.deplacement_avec_port_charges_frequence
    },
    on: {
      "input": function (newValue) {
        _vm.form.deplacement_avec_port_charges_frequence = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "deplacement_avec_port_charges_poids",
      "libelle": "Poids maximum",
      "necessary": true,
      "value": _vm.form.deplacement_avec_port_charges_poids
    },
    on: {
      "input": function (newValue) {
        _vm.form.deplacement_avec_port_charges_poids = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "md:col-span-full",
    attrs: {
      "name": "deplacement_environnement_travail_comment",
      "libelle": "Commentaires",
      "necessary": false,
      "value": _vm.form.deplacement_environnement_travail_comment,
      "size": "3"
    },
    on: {
      "input": function (newValue) {
        _vm.form.deplacement_environnement_travail_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full text-base text-indigo-600 mt-10"
  }, [_vm._v("PLAN DE TRAVAIL")]), _vm._v(" "), _c('multiple-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "plan_travail",
      "libelle": "Plan de travail",
      "necessary": true,
      "value": _vm.form.plan_travail,
      "datas": [{
        value: 'Hauteur à respecter'
      }, {
        value: 'Assise à ajuster'
      }, {
        value: 'Champ visuel à respecter'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.plan_travail = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "condition_eclairage_spe",
      "libelle": "Condition d'éclairage spécifique",
      "necessary": true,
      "value": _vm.form.condition_eclairage_spe
    },
    on: {
      "input": function (newValue) {
        _vm.form.condition_eclairage_spe = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "condition_eclairage_spe_precis",
      "libelle": "Précisez",
      "necessary": false,
      "value": _vm.form.condition_eclairage_spe_precis
    },
    on: {
      "input": function (newValue) {
        _vm.form.condition_eclairage_spe_precis = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "md:col-span-full",
    attrs: {
      "name": "plan_travail_comment",
      "libelle": "Commentaires",
      "necessary": false,
      "value": _vm.form.plan_travail_comment,
      "size": "3"
    },
    on: {
      "input": function (newValue) {
        _vm.form.plan_travail_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full text-base text-indigo-600 mt-10"
  }, [_vm._v("AMENAGEMENT INFORMATIQUE")]), _vm._v(" "), _c('multiple-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "amenagement_informatique",
      "libelle": "Aménagement informatique",
      "necessary": true,
      "value": _vm.form.amenagement_informatique,
      "datas": [{
        value: 'PC fixe'
      }, {
        value: 'PC portable'
      }, {
        value: 'Double écrans'
      }, {
        value: 'Verticalisateur de documents'
      }, {
        value: 'Souris/ Clavier sans fil'
      }, {
        value: 'Souris spécifique'
      }, {
        value: 'Clavier spécifique'
      }, {
        value: 'Réglage écran (Contraste / Couleurs)'
      }, {
        value: 'Réglages caractères'
      }, {
        value: 'Réglages environnement (Windows, Mac...)'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.amenagement_informatique = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "amenagement_informatique_precis",
      "libelle": "Précisez",
      "necessary": false,
      "value": _vm.form.amenagement_informatique_precis
    },
    on: {
      "input": function (newValue) {
        _vm.form.amenagement_informatique_precis = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "taille_ecran_min",
      "libelle": "Taille écran minimum",
      "necessary": true,
      "value": _vm.form.taille_ecran_min
    },
    on: {
      "input": function (newValue) {
        _vm.form.taille_ecran_min = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "md:col-span-full",
    attrs: {
      "name": "amenagment_informatique_comment",
      "libelle": "Commentaires",
      "necessary": false,
      "value": _vm.form.amenagment_informatique_comment,
      "size": "3"
    },
    on: {
      "input": function (newValue) {
        _vm.form.amenagment_informatique_comment = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full text-base text-indigo-600 mt-10"
  }, [_vm._v("ADAPTATION DES DOCUMENTS")]), _vm._v(" "), _c('multiple-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "adaptation_documents",
      "libelle": "Adaptation des documents",
      "necessary": true,
      "value": _vm.form.adaptation_documents,
      "datas": [{
        value: 'Agrandissement format de document'
      }, {
        value: 'Contraste / Couleurs'
      }, {
        value: 'Surlignage des titres'
      }, {
        value: 'Supports aérés'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.adaptation_documents = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "adaptation_document_precis",
      "libelle": "Précisez",
      "necessary": false,
      "value": _vm.form.adaptation_document_precis
    },
    on: {
      "input": function (newValue) {
        _vm.form.adaptation_document_precis = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "taille_caracteres",
      "libelle": "Taille des caractères",
      "necessary": true,
      "value": _vm.form.taille_caracteres
    },
    on: {
      "input": function (newValue) {
        _vm.form.taille_caracteres = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "md:col-span-full",
    attrs: {
      "name": "adaptation_documents_comment",
      "libelle": "Commentaires",
      "necessary": false,
      "value": _vm.form.adaptation_documents_comment,
      "size": "3"
    },
    on: {
      "input": function (newValue) {
        _vm.form.adaptation_documents_comment = newValue;
      }
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }